export default function getRelativePath(href) {
    var _a = new URL(href), pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return pathname + search + hash;
}
